import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import LazyComponent from '../../Components/LazyComponent';
import Meta from '../../Components/Meta';

import Banner from './Banner';
import Gurantee from './Gurantee';
import Courses from './Courses';
import Pro from './Pro';
import Features from './Features';
import RegistrationForm from './RegistrationForm';
import CollaboratedCompanies from './CollaboratedCompanies';
import Faq from './Faq';
import Process from './Process';

import { getCourseLevelCompanies } from '../../selectors/course';

import { fetchCurrentCourseCourseLevel } from '../../actions/courseLevel';

import './style.css';

class ThreeHundred extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    };
  }

  async componentDidMount() {
    try {
      this.toggleLoading();
      await this.props.fetchCurrentCourseCourseLevel('ML');
      this.toggleLoading();
    } catch (err) {
      this.toggleLoading();
    }
  }

  toggleLoading = () => {
    this.setState(prevState => ({
      isLoading: !prevState.isLoading
    }));
  };

  downloadBroucher = () => {
    const link = document.createElement('a');
    link.href =
      'https://firebasestorage.googleapis.com/v0/b/education-ademia-4840a.appspot.com/o/300.pdf?alt=media&token=bb34309d-41e3-4852-9c02-c9dc2c500610';
    link.target = '_blank';
    link.click();
    link.remove();
  };

  render() {
    const { levelCompanies } = this.props;
    return (
      <React.Fragment>
        <Meta
          title="300+ Hours Mentorship | Alien Brains Educations"
          description="Training + Internship + Pre-Placement Assistance by Industry Professionals. Register for free 15 hours of demo class. No prerequisite knowledge required. EMI Available."
        />
        <Banner
          downloadBroucher={this.downloadBroucher}
        />
        <Gurantee />

        <Courses />

        <Pro />

        <Features />

        <Process />

        <CollaboratedCompanies companies={levelCompanies} />

        <RegistrationForm />

        <LazyComponent>
          <Faq />
        </LazyComponent>

        {/* <LazyComponent>
          <ExploreCourses
            title="Mentoring you the way, you wanted "
            description="Jump start your career now"
            actionText="Book Your Seats Now"
            onClick={() => {}}
          />
        </LazyComponent> */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (store, props) => {
  return {
    levelCompanies: getCourseLevelCompanies(store, props)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchCurrentCourseCourseLevel
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ThreeHundred);



// WEBPACK FOOTER //
// ./src/Pages/ThreeHundred/index.js